import { Dispatch } from "redux";
import { fetchApi } from "../../common/api";
import { User } from "./types";

export enum USER_ACTION {
  SET_USER_ACTION = "SET_USER_ACTION",
  UPDATE_USER_ACTION = "UPDATE_USER_ACTION",
}

export interface SetUserAction {
  type: USER_ACTION.SET_USER_ACTION;
  user: User;
}

export const setUserAction = (user: User) => {
  return async (dispatch: Dispatch<SetUserAction>) => {
    const action: SetUserAction = {
      type: USER_ACTION.SET_USER_ACTION,
      user,
    };

    dispatch(action);
    return action;
  };
};

export interface UpdateUserAction {
  type: USER_ACTION.UPDATE_USER_ACTION;
  updatedUser: User;
}

export const updateUserAction = (
  userId: string,
  email: string,
  firstName: string,
  lastName: string,
) => {
  return async (dispatch: Dispatch<UpdateUserAction>) => {
    const updatedUser = await fetchApi<User>("/users/update", "POST", {
      id: userId,
      email,
      first_name: firstName,
      last_name: lastName,
    });

    const action: UpdateUserAction = {
      type: USER_ACTION.UPDATE_USER_ACTION,
      updatedUser,
    };

    dispatch(action);
    return action;
  };
};
